import React, { useEffect } from 'react'

const PreloaderCustom = () => {

    useEffect(() => {
        document.body.style.margin = 0
    }, [])

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            margin: 0,
            padding: 0,
            height: '100vh',
            width: '100vw',
            zIndex: 100,
            position: 'fixed'
        }}>
            <img
                className='animate__animated animate__fadeIn'
                src={`${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/pageload-spinner.gif`}
                alt="Preloader Andes Salud"
                width={70}
            />
        </div>
    )
}

export default PreloaderCustom